import lozad from 'lozad';

let observer;

function init() {
	observer = lozad('.js-lazy', {
		rootMargin: '10px 0px', // syntax similar to that of CSS Margin
		threshold: 0.1, // ratio of element convergence
		enableAutoReload: true, // it will reload the new image when validating attributes changes
		loaded(el) {
			el.classList.add('is-loaded');
		},
	});

	observer.observe();
}

function trigger(img) {
	observer.triggerLoad(img);
}

export default {
	init,
	trigger,
};

